<template>
	<section :style="{'background-color':bgColor}" class="carousel">
		<div v-bind:class="{carousel_boxed: isBoxed, border_desktop: hasMask}">
			<div class="carousel_container">
				<carousel
						:key="carouselKey"
						:autoplay=true
						:autoplayTimeout=2000
						:dots=false
						:items=1
						:loop=true
						:nav=false
						:smartSpeed=750
						class="carousel_content"
				>
					<img
							v-for="carouselImage in carouselImages"
							v-bind:key="carouselImage.id"
							:src="imgPath(carouselImage.image)"
							class="carousel_list_element"
					/>
				</carousel>
			</div>
		</div>
	</section>

</template>

<script>

import Vue2Filters from "vue2-filters";
import carousel from "vue-owl-carousel2";

export default {
	name: "Carousel",
	mixins: [Vue2Filters.mixin],
	components: {
		carousel
	},
	data: function () {
		return {
			hasMask: (this.mask),
			isBoxed: (this.boxed),
			carouselKey: 0,
			svgKey: 0
		};
	},
	props: {
		carouselImages: {
			type: Array
		},
		image: {
			type: String,
			default: ""
		},
		mask: {
			type: String,
			default: ""
		},
		boxed: {
			type: String,
			default: ""
		},
		bgColor: {
			type: String,
			default: "transparent"
		}
	},

	methods: {
		imgPath: function (image) {
			return require("../assets/images/" + image);
		},
		carouselMask: function () {
			setTimeout(() => {
				this.carouselMask();
			}, 250);
		}
	},
	mounted() {
		this.carouselMask();
	},
	created() {
		window.addEventListener("resize", this.carouselMask);
	},

	destroyed() {
		window.removeEventListener("resize", this.carouselMask);
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@use '@/assets/scss/partials/variables' as *;
@use '@/assets/scss/partials/mixins' as *;


.carousel {
	padding: 5rem;
	position: relative;

	&_boxed {
		margin: auto;
		max-width: 110rem;
		position: relative;
		@include breakpoint(lt-sm) {
			padding: 3.5rem;
		}

		.carousel_container {
			.carousel_content {
				box-sizing: border-box;
				position: relative;
			}
		}
	}
}

</style>
